import CoreComponent from '../CoreComponent.vue';
export default {
  extends: CoreComponent
};